<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="service-fee-batch-import-dialog ah-detail-dialog"
        top="5vh"
        @close="onClose"
        @open="onOpen"
    >
        <template slot="title">批次匯入勞報單</template>
        <div>
            <a v-show="false" ref="ExampleLink" :href="`/download/勞報單批次匯入範例v1.xlsx`" download style="margin-left: 10px">下載範本</a>
            <input v-show="false" ref="fileInput" type="file" accept=".csv,.xlsx" @change="onFileInputChange" />
            <div v-if="validatedItems.length === 0" style="height: calc(85vh - 54px - 75px)" class="first-view">
                <el-button :loading="isUploading" @click="onDownloadExample">下載 Excel 匯入範本</el-button>
                <el-button v-if="!isQR()" :loading="isUploading" @click="onUploadSheet">上傳 Excel</el-button>
            </div>
            <el-table
                v-if="validatedItems.length > 0"
                :data="validatedItems"
                :cell-class-name="tableCellClass"
                class="validate-table"
                style="width: 100%; border-top: 1px solid #eee"
                height="calc(85vh - 54px - 75px)"
                size="mini"
                border
            >
                <el-table-column fixed type="index" label="#" width="50"></el-table-column>
                <el-table-column fixed prop="status" label="驗證狀態" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 'OK'" type="normal" effect="dark">可以匯入</el-tag>
                        <el-tag v-if="scope.row.status === 'ERROR'" type="danger" effect="dark">無法匯入</el-tag>
                        <el-tag v-if="scope.row.status === 'SUCCESS'" type="success" effect="dark"><i class="el-icon-check"></i> 已匯入</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-for="(col, key) in ExcelColumns" :key="key" :fixed="col.fixed" :prop="key" :label="col.label" :width="col.width" :align="col.align">
                    <template slot-scope="scope">
                        <div v-if="col.type === 'text' || col.type === 'number'">{{ scope.row[key].value }}</div>
                        <Money v-if="col.type === 'money'" :v="scope.row[key].value" />
                        <cell-validate-label :status="scope.row[key].status" :msg="scope.row[key].msg" />
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="validatedItems.length > 0" class="dialog-footer" style="display: flex; justify-content: space-between; align-items: center">
            <div>
                <template v-if="!isImporting">
                    <el-button type="" icon="el-icon-close" @click="onClose">取消</el-button>
                    <el-button v-if="!isQR()" :loading="isUploading" icon="el-icon-upload2" @click="onUploadSheet">重新上傳 Excel</el-button>
                </template>
                <template v-else>
                    <div style="width: 300px">
                        <el-progress :percentage="importPercentage" :show-text="false"></el-progress>
                    </div>
                </template>
            </div>
            <el-tooltip class="item" effect="dark" content="請先排除無法匯入的項目再重新上傳" placement="top" :manual="isAllDataValid">
                <el-button v-if="!isQR()" type="primary" icon="el-icon-check" class="primary-action" :disabled="!isAllDataValid" :loading="isImporting" @click="onImport">匯入</el-button>
            </el-tooltip>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import XLSX from 'xlsx';
import { serviceTypeList } from '@/assets/commonData/options';
import ExcelColumns from './ExcelColumns'; // 所有欄位的定義
import ExcelImportError from './ExcelImportError';
import CellValidateLabel from './CellValidateLabel.vue';

export default {
    components: {
        CellValidateLabel,
    },
    props: {
        visible: Boolean,
    },
    computed: {
        isAllDataValid() {
            return this.validatedItems.every((item) => item.status === 'OK');
        },
    },
    data() {
        return {
            isUploading: false,
            isImporting: false,
            importPercentage: 0,
            ExcelColumns, // 所有欄位的定義
            validatedItems: [
                // 驗證後顯示於表單的資料
                //    {
                //      value: '', // 每欄的原始資料,
                //      status: 'NONE | OK | WARNING | ERROR', //驗證狀態
                //      msg: '', // 驗證訊息
                //    },
            ],
        };
    },
    methods: {
        // 產生每一格的 class 名稱
        tableCellClass({ rowIndex, column }) {
            const cellItem = this.validatedItems[rowIndex][column.property];
            if (cellItem) {
                return `validate-cell ${cellItem.status}`;
            }
            return null;
        },

        // 開啟
        onOpen() {
            console.log('onOpen');
        },

        // 關閉
        onClose(refresh) {
            this.validatedItems = [];
            this.$refs.fileInput.value = '';
            this.$emit('close', refresh);
        },

        // 下載範例檔
        onDownloadExample() {
            this.$refs.ExampleLink.click();
        },

        // 觸發系統上傳檔案視窗
        onUploadSheet() {
            this.$refs.fileInput.value = '';
            this.$refs.fileInput.click();
        },

        // 選擇 Excel 檔後，讀取檔案內容
        onFileInputChange(event) {
            if (!event.target.files[0]) return;
            const inputFile = event.target.files[0];
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
                    if (!wb) throw new ExcelImportError('無效的檔案，請檢查後重新上傳');

                    // 取得目標分頁
                    const targetSheetName = '資料輸入頁，請勿刪除表頭';
                    const targetSheet = wb.Sheets[targetSheetName];
                    if (!targetSheet) throw new ExcelImportError('找不到有效的分頁。');

                    // 分頁轉換資料為 JSON
                    const columnKeys = Object.keys(ExcelColumns);
                    const rawRows = XLSX.utils.sheet_to_json(targetSheet, { header: columnKeys, dateNF: 'yyyy-mm-dd' });

                    // 移除前三行
                    rawRows.shift();
                    rawRows.shift();
                    rawRows.shift();

                    // 清除空白行
                    const cleanRows = rawRows.filter((row) => row.bsn);

                    // 開始驗證資料
                    this.isUploading = true;
                    this.validatedItems = await this.validate(cleanRows);
                    this.isUploading = false;
                } catch (err) {
                    this.$message({ showClose: true, message: err.msg, type: 'error' });
                }
            };
            reader.readAsArrayBuffer(inputFile);
        },

        // 驗證資料
        async validate(rows) {
            console.log('rows', rows);

            // 逐行
            const validatedItems = [];
            for (let i = 0; i < rows.length; i += 1) {
                const row = rows[i];
                // 建立一筆資料物件
                const item = {};

                // eslint-disable-next-line no-await-in-loop
                const existOutsource = await this.fetchOutsourceByBsn(row.bsn); // 取已有的委外個人
                // eslint-disable-next-line no-await-in-loop
                const existProject = await this.fetchProjectByPoo(row.poo); // 取已有的專案

                // 逐欄
                let hasError = false;
                const columnKeys = Object.keys(ExcelColumns);
                columnKeys.forEach((colKey) => {
                    // 建立欄位資料 { value, status, msg }
                    const value = row[colKey];
                    const { type } = ExcelColumns[colKey];

                    // 建立欄位資料
                    item[colKey] = { value, status: 'NONE', msg: '' };

                    // 資料型態轉換
                    switch (type) {
                    case 'number':
                    case 'money':
                        item[colKey].value = value ? Number(value) : 0;
                        break;

                    case 'text':
                        item[colKey].value = value ? value.toString() : '';
                        break;

                    case 'date':
                        item[colKey].value = value ? moment(value).format('YYYY-MM-DD') : '';
                        break;

                    default:
                    }

                    // 取得驗證函式
                    const vaidateFunc = ExcelColumns[colKey].validate;
                    if (vaidateFunc) {
                        const { status, msg } = vaidateFunc(value, row, { existOutsource, existProject });
                        item[colKey].status = status;
                        item[colKey].msg = msg;

                        if (status === 'ERROR') {
                            hasError = true;
                        }
                    }
                });

                item.status = hasError ? 'ERROR' : 'OK'; // 整筆可否匯入的標記
                validatedItems.push({ ...item, existProject, existOutsource });
            }
            console.log('validatedItems', validatedItems);
            return validatedItems;
        },

        // 取得委外個人
        async fetchOutsourceByBsn(bsn) {
            if (!bsn) return null;

            const resp = await this.$api({
                url: 'ServiceOrder/GetOutsourcingByBsn',
                method: 'GET',
                params: { bsn },
            });
            return resp.data.item;
        },

        // 取得專案
        async fetchProjectByPoo(poo) {
            if (!poo) return null;

            const resp = await this.$api({
                url: 'ServiceOrder/GetProjectByPoo',
                method: 'GET',
                params: { poo },
            });
            return resp.data.item;
        },

        // 匯入
        async onImport() {
            try {
                this.isImporting = true;
                this.importPercentage = 0;
                for (let i = 0; i < this.validatedItems.length; i += 1) {
                    // 進度條
                    this.importPercentage = (i / this.validatedItems.length) * 100;

                    // 轉換為 API 資料格式
                    const data = this.convertToApiForm(this.validatedItems[i]);

                    // 新增勞報單
                    // eslint-disable-next-line no-await-in-loop
                    await this.upsertServiceFeeStatement(data);

                    this.validatedItems[i].status = 'SUCCESS';
                }
            } catch (e) {
                console.log(e);
                this.$message({ showClose: true, message: '匯入時出現問題', type: 'error' });
            } finally {
                this.isImporting = false;
                this.importPercentage = 0;
                this.$message.success('已建立勞報單');
            }
        },

        // 新增勞報單
        async upsertServiceFeeStatement(data) {
            await this.$api({
                url: 'ServiceOrder/UpsertServiceFeeStatement',
                method: 'POST',
                data,
            });
        },

        // 轉換為 API 資料格式
        convertToApiForm(validatedItem) {
            const returnItem = {
                typ: 1,
                nam: validatedItem.nam.value,
                projectSno: null, // 後專案處理
                description: validatedItem.content.value,
                personalOutsourcingSno: null, // 後委外處理
                caT_SNO: null, // 後委外處理
                nationality: null, // 後委外處理
                idTyp: null, // 後委外處理
                bsn: null, // 後委外處理
                bsN_TYP: null, // 後委外處理
                payee: validatedItem.outsourceNam.value,
                phone: null, // 後委外處理
                email: null, // 後委外處理
                permanentAddrCty: null, // 後委外處理
                permanentAddr: null, // 後委外處理
                contactAddrCty: null, // 後委外處理
                contactAddr: null, // 後委外處理
                idCardFront: null, // 後委外處理
                idCardBack: null, // 後委外處理
                unionInsuranceDoc: null, // 後委外處理
                passbookDoc: null, // 後委外處理
                incomeType: _.find(serviceTypeList, ['type', validatedItem.incomeTyp.value]).value,
                serviceType: validatedItem.serviceTyp.value ? Number(validatedItem.serviceTyp.value.substring(3, 5)) : null,
                plannedPayDat: +moment(validatedItem.plannedPayDat.value).startOf('day').format('x'),
                plannedPayWay: validatedItem.plannedPayWay.value === '銀行轉帳' ? 2 : 1,
                bnkBoo: null, // 後委外帳戶處理
                bnkDoo: null, // 後委外帳戶處理
                bnkNam: null, // 後委外帳戶處理
                bnkAcc: null, // 後委外帳戶處理
                amt: validatedItem.amt.value ? Number(validatedItem.amt.value) : 0,
                cny: validatedItem.cny.value,
                cnyRat: validatedItem.cnyRat.value ? Number(validatedItem.cnyRat.value) : 1,
                hasUnionInsurance: null, // 後委外處理,
                unionInsuranceExpireDate: null, // 後委外處理,
                taxRatio: validatedItem.taxRatio.value ? Number(validatedItem.taxRatio.value) : 0,
                taxAmt: validatedItem.taxAmt.value ? Number(validatedItem.taxAmt.value) : 0,
                gen2Ratio: validatedItem.gen2Ratio.value ? Number(validatedItem.gen2Ratio.value) : 0,
                gen2Amt: validatedItem.gen2Amt.value ? Number(validatedItem.gen2Amt.value) : 0,
                realPayAmt: validatedItem.realPayAmt.value ? Number(validatedItem.realPayAmt.value) : 0,
                permanentAddrAra: null, // 後委外處理,
                contactAddrAra: null, // 後委外處理
                accountType: null, // 後委外帳戶處理
                abroadBankName: null, // 後委外帳戶處理
                swiftCode: null, // 後委外帳戶處理
                otherServiceType: validatedItem.otherServiceType.value,
                vdR_BNK_SNO: null, // 後委外帳戶處理
            };

            if (validatedItem.existProject) returnItem.projectSno = validatedItem.existProject.sno;

            if (validatedItem.existOutsource) {
                returnItem.personalOutsourcingSno = validatedItem.existOutsource.sno;
                returnItem.caT_SNO = validatedItem.existOutsource.caT_SNO;
                returnItem.nationality = validatedItem.existOutsource.abd;
                returnItem.idTyp = validatedItem.existOutsource.identificationType || 0;
                returnItem.bsn = validatedItem.existOutsource.bsn;
                returnItem.bsN_TYP = validatedItem.existOutsource.bsN_TYP;
                returnItem.phone = validatedItem.existOutsource.vendorContacts[0].tel;
                returnItem.email = validatedItem.existOutsource.vendorContacts[0].eml;
                returnItem.permanentAddrCty = validatedItem.existOutsource.permanentAddrCty;
                returnItem.permanentAddrAra = validatedItem.existOutsource.permanentAddrAra;
                returnItem.permanentAddr = validatedItem.existOutsource.permanentAddr;
                returnItem.contactAddrCty = validatedItem.existOutsource.cty;
                returnItem.contactAddrAra = validatedItem.existOutsource.ara;
                returnItem.contactAddr = validatedItem.existOutsource.adr;
                returnItem.idCardFront = validatedItem.existOutsource.idCardFront;
                returnItem.idCardBack = validatedItem.existOutsource.idCardBack;
                returnItem.unionInsuranceDoc = validatedItem.existOutsource.unionInsuranceDoc;
                returnItem.hasUnionInsurance = validatedItem.existOutsource.oS_GRP;
                returnItem.unionInsuranceExpireDate = validatedItem.existOutsource.unionInsuranceExpireDate;

                const BNK = _.find(validatedItem.existOutsource.vendorBanks, ['bnK_ACC', validatedItem.bnkAcc.value]);
                if (BNK) {
                    returnItem.bnkBoo = BNK.bnK_BOO;
                    returnItem.bnkDoo = BNK.bnK_DOO;
                    returnItem.bnkNam = BNK.bnK_TPC;
                    returnItem.bnkAcc = BNK.bnK_ACC;
                    returnItem.accountType = BNK.accountType;
                    returnItem.abroadBankName = BNK.abroadBankName;
                    returnItem.swiftCode = BNK.swiftCode;
                    returnItem.vdR_BNK_SNO = BNK.sno;
                    returnItem.passbookDoc = BNK.passbookDoc;
                }
            }

            // 現金勞報單，去除帳戶資訊
            if (returnItem.plannedPayWay === 1) {
                returnItem.accountType = null;
                returnItem.bnkBoo = null;
                returnItem.bnkDoo = null;
                returnItem.abroadBankName = null;
                returnItem.swiftCode = null;
                returnItem.bnkNam = null;
                returnItem.bnkAcc = null;
                returnItem.vdR_BNK_SNO = null;
            }

            // 本國帳戶，去除國外帳戶資訊／外國帳戶，去除本國帳戶資訊
            if (returnItem.accountType === 1) {
                returnItem.abroadBankName = null;
                returnItem.swiftCode = null;
            } else if (returnItem.accountType === 2) {
                returnItem.bnkBoo = null;
                returnItem.bnkDoo = null;
            }

            // 非9A, 9B所得類別，去除業別代號
            if (!(returnItem.incomeType === 1 || returnItem.incomeType === 2)) returnItem.serviceType = null;

            // 非其他所得類別，去除其他業別代號
            if (returnItem.incomeType !== 0) returnItem.otherServiceType = null;

            // 幣別為台幣，去除匯率
            if (returnItem.cny === 'TWD') returnItem.cnyRat = 1;

            return returnItem;
        },
    },
};
</script>
<style lang="scss">
.service-fee-batch-import-dialog.ah-detail-dialog {
    .el-dialog {
        width: 100%;
        max-width: 90vw;
        height: 85vh;
        margin-bottom: 5vh !important;
    }
    .dialog-header {
        height: 75px;
        padding: 15px;
    }
    .dialog-footer {
        height: 75px;
        padding: 15px;
    }
    .first-view {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .validate-table {
        .validate-cell {
            &.ERROR {
                background-color: #ffeded;
            }
            &.WARNING {
                background-color: #fffced;
            }
        }
        .hover-row {
            .validate-cell {
                &.ERROR {
                    background-color: rgb(255, 226, 226);
                }
                &.WARNING {
                    background-color: #fff9dd;
                }
            }
        }
    }
}
</style>
